import { FC } from "react"

type Props = {
    isChecked: boolean
}

/**
 * CheckboxComponent 
 * @param isChecked If the input checkbox is checked or not  
 * @returns 
 */
const CheckboxComponent: FC<Props> = ({ isChecked }) => {
    return (
        <>
            <input style={{ width: "1.2rem", height: "1.2rem", borderRadius: "10px" }}
                className="form-check-input opacity-100 no-img-checkbox"
                type="checkbox" name="flexRadioDefault" id="flexRadioDefault1"
                checked={isChecked} disabled />
        </>
    )
}

export { CheckboxComponent }